import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL, FILE_BASE_URL } from '../../../apiConfig';
import { motion } from 'framer-motion';

function BtclPartner() {
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        let isMounted = true;
        axios.get(`${API_BASE_URL}/partners`).then((res) => {
            if (isMounted && res.data.partners) {
                setPartners(res.data.partners);
            }
        }).catch(err => console.error("Partners error:", err));
        return () => { isMounted = false; };
    }, []);

    if (partners.length === 0) return null;

    return (
        <div id="btcl-partners-container" style={{ 
            maxWidth: 'var(--maxWidth)', 
            margin: '0 auto 60px auto', 
            padding: '0 24px' 
        }}>
            <h2 style={{
                fontFamily: 'var(--fontDisplay)', // Barlow Condensed
                fontSize: '24px',
                fontWeight: 700,
                color: '#000',
                margin: '0 0 32px 0',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }}>
                Official Partners
            </h2>

            <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                justifyContent: 'center', 
                alignItems: 'center', 
                gap: '48px',
                padding: '40px',
                background: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid rgba(0,0,0,0.05)'
            }}>
                {partners.map((partner, i) => (
                    <motion.div
                        key={i}
                        whileHover={{ scale: 1.05 }}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                        }}
                    >
                        <img 
                            src={`${FILE_BASE_URL}/${partner.logo}`} 
                            alt={`Partner ${i}`}
                            className="partner-logo"
                            style={{ 
                                height: '50px', 
                                width: 'auto', 
                                objectFit: 'contain',
                                filter: 'grayscale(100%) opacity(0.5)',
                                transition: 'filter 0.3s ease'
                            }} 
                        />
                    </motion.div>
                ))}
            </div>

            <style>{`
                .partner-logo:hover {
                    filter: grayscale(0%) opacity(1) !important;
                }
                @media (max-width: 600px) {
                    #btcl-partners-container div { gap: 24px; padding: 24px; }
                    .partner-logo { height: 35px; }
                }
            `}</style>
        </div>
    );
}

export default BtclPartner;